
import { ReceiverDTO } from '@/models'
import { defineComponent } from 'vue'
import { receiverDisplayName } from '@/helpers/functions'

export default defineComponent({
  name: 'ReceiverItem',
  props: {
    receiver: {
      type: ReceiverDTO,
      required: true
    }
  },
  data() {
    return { receiverDisplayName }
  },
  methods: {
    getFirstLetterOfReceiver(receiver: ReceiverDTO) {
      const words = receiverDisplayName(receiver).trim().split(/\s+/)
      const first = words[0]?.charAt(0) ?? ''
      const second = words.length > 1 ? words[1].charAt(0) : ''
      return (first + second).toUpperCase()
    },
    edit(receiver: ReceiverDTO) {
      this.$emit('edit', receiver)
    },
    selectReceiveToDelete(receiver: ReceiverDTO) {
      this.$emit('delete', receiver)
    },
    sendMoneyTo(receiver: ReceiverDTO) {
      this.$router.push({
        name: 'SendMoney',
        params: {
          receiver: `${receiver.id}`
        }
      })
    }
  }
})
